import { Grid } from "@mui/material";
import Resource1Uploads from "./Resource1Uploads";
import ResourceIVUploads from "./ResourceIVUploads";
import ResourceVUploads from "./ResourceVUploads";
import FamilyQuestionnaireUploads from "./FamilyQuestionnaireUploads";
import AdditionalForms from "./AdditionalForms";
import MyUploadStatus from "./MyUploadStatus";
import { SummaryCompleteProps } from "../../app/models/SummaryComplete";
import CdaEduUpload from "./CdaEduUpload";

export default function MyUploads() {
  const summaryCompleteProps: SummaryCompleteProps = {
    title: "My Uploads",
    percent: "10%",
    header: "",
    description: `Here you can review everything you have uploaded to your portfolio to make sure you have uploaded the correct items. Click on the down arrow to download and review, click on the trashcan to delete, click on Upload Documentation button to upload.`,
  };

  return (
    <Grid container p={2} m={1}>
      <MyUploadStatus {...summaryCompleteProps} />
      <CdaEduUpload />
      <Resource1Uploads />
      <ResourceIVUploads />
      <ResourceVUploads />
      <FamilyQuestionnaireUploads />
      <AdditionalForms />
    </Grid>
  );
}
